
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es-co/ia/reasignacion-carga",
      function () {
        return require("private-next-pages/es-co/ia/reasignacion-carga/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es-co/ia/reasignacion-carga"])
      });
    }
  